import { z } from "zod";

export const getArticleParamSchema = z.object({
	articleId: z.uuid(),
});

export type GetArticleParamSchema = z.infer<typeof getArticleParamSchema>;
